import { Component, OnInit,OnDestroy, ViewChild, Renderer2 , ElementRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Modal } from 'angular2-modal/plugins/bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { EchexpaymentService } from '../echexpayment.service';
import { GlobalEventMangerService } from '../global-event-manger.service';
import { LocalstorageService } from '../localstorage.service';
import { UserService } from '../user.service';
import { NgForm } from '@angular/forms';
@Component({
  selector: 'echexpayment-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.css']
})
export class AccountComponent implements OnInit , AfterViewInit, OnDestroy {
@ViewChild('c') c : NgForm;
	busy: Subscription;
	public token: string;
	public id: string;
	public user_token: string;

	public planName: string;
	public stripe_plan: string;
	public stripe_id: string;

	public data;
	public invoicedata;
	public filterQuery = "";
	public rowsOnPage = 10;
	public sortBy = "Id";
	public sortOrder = "asc";
	public invoiceList = false;
	public subscriptionsData;
	public allPlanData;
	public filterPlanData;
	public settingsData;
	public showBillingForm = false;
	public stripeStatus: string;
	

	public val_plan: boolean=false;
	public formTouched : boolean = false;

	public paymentMethod : any = {plan: ''};
	public userData= <any>{};
	public expYear : string;
	public expMonth : string;
	public cardLastFour : string;
	public MonthError : boolean = false;
	public CardError : boolean = false;
	public CardErrorMessage : string;
	public YearError : boolean = false;
	public CVCError : boolean = false;
	public MaxYear : boolean = false;
	public mask: Array<string | RegExp>;
	@ViewChild('inputYear', {  read: ElementRef }) inputYear: ElementRef;

	constructor(private echexpaymentService: EchexpaymentService, private elementRef: ElementRef, private renderer: Renderer2, private router: Router,  private toastr: ToastrService, private  route: ActivatedRoute, private userService: UserService, public modal: Modal, private globalEventMangerService: GlobalEventMangerService, private localStorageService: LocalstorageService) { 
		this.router = router;
		var currentUser =  this.localStorageService.getData("currentUserToken");
		this.token =  currentUser.data.user_token;
		let userDetails = this.localStorageService.getData("currentUser");
		this.id = userDetails._id;
		this.mask = [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];

		if(userDetails.subscriptions != null){
			this.planName = userDetails.subscriptions.plan;
			this.stripe_plan = userDetails.subscriptions.stripe_plan;
			this.stripe_id = userDetails.subscriptions.stripe_id;
		}
		

	}
	ngOnDestroy() {
		this.toastr.clear();
	}

	ngOnInit() {
		this.getEchecksPlan();
		this.getUserDetailById();
		
	}
	
	ngAfterViewInit() {
	}

	moveNext(nextInput: HTMLInputElement, checkbox) {
		if(checkbox === 2){
			const saveButton = document.getElementById('submitButton') as HTMLElement;
			if (saveButton) {
				saveButton.focus();
				saveButton.click();
			}
		} else{
			nextInput && nextInput.focus();
		}
	}

	focusFirstInvalidControlPlus(): void {
		const firstElementWithErrors: HTMLElement = this.elementRef.nativeElement.querySelector(`form .ng-invalid`);
		if (firstElementWithErrors) {
			firstElementWithErrors.focus();
		}
	}
	// get echex plan 
	getEchecksPlan(){
		var data = {
			token :this.token,
		}
		let responseData = <any>{};
		this.busy = this.echexpaymentService.getAllPlan(data).subscribe(
		 response => {
		   responseData = response;
		   this.allPlanData =  JSON.parse(JSON.stringify(responseData.data.data));
		   this.filterData();
		 },
		 error => {
			responseData = error;
			this.toastr.error(responseData.error.message, 'Failed!');
		 }
		);
	}


	// get user details by ids
	getUserDetailById(){
		var data = {
			  token :this.id,
			  user_token :this.token,
			 _id :this.id
		  }
		 let responseData = <any>{}; 
		 this.busy = this.userService.getUserDetailByIdApi(data).subscribe(
		   response => {
				responseData = response;
				this.expYear = responseData.data.exp_year;
				this.expMonth = responseData.data.exp_month;
				this.cardLastFour = responseData.data.card_last_four;
				if (typeof responseData.data.next_invoice_date === 'string') {
					this.paymentMethod.next_invoice_date = responseData.data.next_invoice_date;
				  } else {
					this.paymentMethod.next_invoice_date = '';
				}
				// if(responseData.data.subscriptions != null){
				// 	this.paymentMethod.plan = responseData.data.subscriptions['plan'];
				// }
				this.userData.status_id = responseData.data.status_id;
				this.settingsData = responseData.data.settings; 
				if(responseData.data.subscriptions != null){
					var usersJson: any[] = Array.of(responseData.data.subscriptions);
					this.subscriptionsData = responseData.data.subscriptions;
					this.stripeStatus = this.subscriptionsData[0].stripe_status;
					this.filterData();
				}
				
		   },
		   error => {
				responseData = error;
				this.toastr.error(responseData.error.message, 'Failed!');
		   }
		);
	}

	filterData() {
		if(typeof(this.allPlanData) !== 'undefined' && typeof(this.subscriptionsData) !== 'undefined' && this.allPlanData.length > 0 && this.subscriptionsData.length > 0) {
			let active_package_amt = (this.subscriptionsData[0].plan_amount ? this.subscriptionsData[0].plan_amount : 0);
			this.filterPlanData = this.allPlanData.filter(function(item) {
				return (item.amount > parseFloat(active_package_amt) && item.status == 3);
			});
		}
	}

	// Toggle 
	toggleCrediCardDetails(){
		this.showBillingForm = this.showBillingForm ? false : true;
		if (this.showBillingForm) {
			setTimeout(() => {
				const businessNameElement = document.querySelector('#initialFocus') as HTMLInputElement;
				if (businessNameElement) {
				  this.renderer.selectRootElement(businessNameElement).focus();
				}
			}, 0); 
		}
	}
	//update billin and invoice card details
	// hide error message when input box get focus
	eventHandler(){
		this.val_plan = false;

	} 
	onPlanChange(selectPlan: string){
     if(selectPlan === 'custom_plan'){
       this.router.navigate(['account/customplan'])
	 }
	}
	
	DisallowZero(event: any) {
        const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
        const allowedKeyCodes = [46, 8, 9, 27, 13]; // Backspace, Delete, Tab, Escape, Enter
      
        if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
          // Allow the default behavior for certain keys
          return;
        }
      
        const inputValue = event.target.value;
        const caretStart = event.target.selectionStart;
        const caretEnd = event.target.selectionEnd;
        const modifiedValue = inputValue.slice(0, caretStart) + event.key + inputValue.slice(caretEnd);
      
        if (modifiedValue.length === 1 && modifiedValue.charAt(0) === '0') {
          // Prevent input of '0' as the first digit
          event.preventDefault();
          return;
        }
      
        if (!/^\d+(\.\d{0,2})?$/.test(modifiedValue)) {
          // Prevent input if it's not a valid digit or decimal value with a maximum of two decimal places
          event.preventDefault();
        }
      }

	  monthDiff(dateFrom, dateTo) {
		return dateTo.getMonth() - dateFrom.getMonth() + 
		  (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
	   }

	// Update Credit card details
	UpdateCardDetails(data){
		this.focusFirstInvalidControlPlus();   //focus field
		this.formTouched = true;
   
		const currentDate = new Date();
		const currentYear = currentDate.getFullYear();
		const currentMonth = currentDate.getMonth() + 1;
	  
		const enteredYear = parseInt(data.form.value.exp_year, 10);
		const enteredMonth = parseInt(data.form.value.exp_month, 10);

		if (enteredYear < currentYear) {
				const businessNameElement = document.querySelector('#inputYear') as HTMLInputElement;
				if (businessNameElement) {
					this.renderer.selectRootElement(businessNameElement).focus();
					this.YearError = true;
				}
				return
		  } else if (enteredYear === currentYear && enteredMonth < currentMonth) {
			    this.YearError = false;
				const businessNameElement = document.querySelector('#inputMonth') as HTMLInputElement;
				if (businessNameElement) {
					this.renderer.selectRootElement(businessNameElement).focus();
					this.MonthError = true;
				}
				return
		  } else if (this.monthDiff(new Date(currentYear, currentMonth), new Date(enteredYear, enteredMonth)) > 72) {
				this.YearError = false;
				this.MonthError = false;
				const businessNameElement = document.querySelector('#inputYear') as HTMLInputElement;
				if (businessNameElement) {
					this.renderer.selectRootElement(businessNameElement).focus();
					this.MaxYear = true;
				}
				return
		  }
		  
		this.MonthError = false;
		this.YearError = false;
		this.CardError = false;
		this.CardErrorMessage = '';
		this.CVCError = false;
		this.MaxYear = false;
		if(data.valid){
			let model: any = data.value;
			model.token = this.id;
			model.user_token  = this.token
			model._id = this.id;
			
			let responseData = <any>{};
			this.busy = this.userService.UpdateCardDetailsApi(model).subscribe(
				response => {
					this.MonthError = false;
					this.YearError = false;
					this.CardError = false;
					this.CardErrorMessage = '';
					this.MaxYear = false;
					responseData = response;
					this.expYear = model.exp_year;
					this.expMonth = model.exp_month;
					this.cardLastFour = model.number.slice(-4);
					this.c.reset();
					this.formTouched = false;
					this.toastr.success(responseData.message, 'Sucess!');
				},
				error => {
					responseData = error;
					
					if (responseData.error.message.message.indexOf('card number') > -1 ||
					responseData.error.message.message.indexOf('credit card') > -1) {
						const businessNameElement = document.querySelector('#initialFocus') as HTMLInputElement;
						if (businessNameElement) {
						  this.renderer.selectRootElement(businessNameElement).focus();
						  this.CardError = true;
						  this.CardErrorMessage = responseData.error.message.message;
						}
					}
					if (responseData.error.message.message.indexOf('year') > -1) {
						const businessNameElement = document.querySelector('#inputYear') as HTMLInputElement;
						if (businessNameElement) {
						  this.renderer.selectRootElement(businessNameElement).focus();
						  this.YearError = true;
						}
					}
					if (responseData.error.message.message.indexOf('month') > -1) {
						const businessNameElement = document.querySelector('#inputMonth') as HTMLInputElement;
						if (businessNameElement) {
						  this.renderer.selectRootElement(businessNameElement).focus();
						  this.MonthError = true;
						  this.CardError = false;
						  this.CardErrorMessage = '';
						}
					}
					
					if (responseData.error.message.message.indexOf('cvc') > -1) {
						const businessNameElement = document.querySelector('#inputCvc') as HTMLInputElement;
						if (businessNameElement) {
						  this.renderer.selectRootElement(businessNameElement).focus();
						  this.CVCError = true;
						}
					}
					this.toastr.error(responseData.error.message.message, 'Failed!');
				}
			);
		}
	}
// Active now in account from trial
	activeNow() {
		var data = {
		  _id :this.id,
		  token:this.id,
		  user_token: this.token,
		  plan :this.planName,
		  stripe_plan :this.stripe_plan,
		  stripe_id :this.stripe_id,
		}
		let responseData = <any>{};
		this.busy = this.userService.freeTrialToActivate(data).subscribe(
		   response => {
		   responseData = response;
		   this.toastr.success(responseData.message, 'Success!');
				if(responseData.message) {
					this.getAuth();
				}
		   },
		   error => {
				responseData = error;
				this.toastr.error(responseData.error.message, 'Failed!');		   
		   }
		);
	}

	// Upgrade subscription
	upgradeNow(model: any){		
		//upgradeSubscription(data) stripe_plan
		if(typeof model.plan === 'undefined'  || model.plan === null || model.plan === ''){
		  this.val_plan = true;
		  return false;
		}
	
		model.token = this.id;
		model.user_token = this.token;
		model._id = this.id;
		model.stripe_plan = this.stripe_plan;
		
		let responseData = <any>{};

		this.busy = this.userService.upgradeSubscription(model).subscribe(
			response => {
			responseData = response;
			this.toastr.success(responseData.message, 'Success!');
			this.val_plan = false;
				if(responseData.message) {
					this.getAuth();   
			 	}
			},
			error => {
			 responseData = error;
			 this.val_plan = false;
			 this.toastr.error(responseData.error.message, 'Failed!');
			
			}
		);

	}

	getAuth() {
		let authData = <any>{};
		let current_User = this.localStorageService.getData("currentUserToken");
		let token = current_User.data.user_token;
		this.busy = this.userService.getAuthUserByToken(token).subscribe(
			response => {
			 	authData = response;

			 	let parsed_currentUserToken = this.localStorageService.getData("currentUserToken");
				parsed_currentUserToken.data.settings = authData.data.settings;
				parsed_currentUserToken.data.is_steps_completed = true;

				this.localStorageService.setData("currentUserToken", parsed_currentUserToken);
				let parsed_currentUser = this.localStorageService.getData("currentUser");
				parsed_currentUser.settings = authData.data.settings;
				parsed_currentUser.subscriptions = authData.data.subscriptions;
			 	this.localStorageService.setData("currentUser", parsed_currentUser);
			 
			 	this.globalEventMangerService.showNavBar(true);

				location.reload();
			},error => {
				authData = error;
				this.toastr.error(authData.error.message, 'Failed!');
		   	}
		);
	}

	handleTabClick(tabTitle: string) {
		if (tabTitle === 'Plan') {
			this.getUserDetailById();
		} 
		if (tabTitle === 'Billing & Invoices') {
			this.getEchecksPlan();
		}
	}
	
	// Allowing  Number only
	validateNumberInput(event: any) {
		const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
		const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
	  
		if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
		  // Allow the default behavior for certain keys
		  return;
		}
	  
		if (!/^\d+$/.test(event.key)) {
		  // Prevent input if it's not a digit
		  event.preventDefault();
		}
	  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/account/account.component.ts